import React, { useEffect, useState } from 'react';
import { handleAmountChange, handleDateChange, validateForm } from '../utils/formHandlers';
import { handleFileChange, handlePreview } from '../utils/fileHandlers';
import { submitExpense } from '../utils/apiHandlers';
import Header from './Header';
import LoadingSpinner from './LoadingSpinner';
import '../styles.css';

function AddNote({ note, onAddExpense, goToHome, handleLogout }) {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  // Initialiser la date du jour
  useEffect(() => {
    const today = new Date();
    const formattedToday = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
    setDate(formattedToday);
  }, []);



  const onSubmit = async (e) => {
    e.preventDefault();

    const validation = validateForm(amount, date);
    if (!validation) return;

    const { parsedAmount, formattedDate } = validation;

    const formData = new FormData();
    formData.append('noteId', note.id_note);
    formData.append('amount', parsedAmount);
    formData.append('description', description);
    formData.append('date', formattedDate);
    if (file) {
      formData.append('file', file);
    }

    const { success } = await submitExpense(formData);
    
    if (success) {
      setAmount('');
      setDescription('');
      setDate('');
      setFile(null);
      setPreviewUrl(null);
    }
  };

  if (!note) {
    return (
      <div>
        <main>
          <LoadingSpinner message="Chargement de la note..." />
          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <button 
              onClick={goToHome}
              style={{
                padding: '10px 20px',
                backgroundColor: 'black',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Retour à l'accueil
            </button>
          </div>
        </main>
        <footer>
          <Header handleLogout={handleLogout} />
        </footer>
      </div>
    );
  }

  return (
    <div>
      <main>
        <form onSubmit={onSubmit} className="expense-form">
          <div className="form-group">
            <label htmlFor="amount">Montant</label>
            <input
              type="text"
              id="amount"
              value={amount}
              onChange={(e) => setAmount(handleAmountChange(e.target.value))}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <input
              type="text"
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="date">Date</label>
            <input
              type="date"
              id="date"
              value={date}
              onChange={(e) => setDate(handleDateChange(e.target.value))}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="file">Justificatif</label>
            <input
              type="file"
              id="file"
              onChange={(e) => handleFileChange(e, setFile, setPreviewUrl)}
              accept="image/*,.pdf"
            />
            {file && (
              <button
                type="button"
                onClick={() => handlePreview(file, previewUrl)}
                className="preview-button"
              >
                Prévisualiser
              </button>
            )}
          </div>

          <div className="form-actions">
            <button type="submit" className="submit-button">
              Ajouter la dépense
            </button>
            <button type="button" onClick={goToHome} className="cancel-button">
              Annuler
            </button>
          </div>
        </form>
      </main>
      <footer>
        <Header handleLogout={handleLogout} />
      </footer>
    </div>
  );
}

export default AddNote;
